import pickedObjectTypes from '../../types/pickedObjectTypes';

const isWall = (currentPickedObject: any): boolean => {
  if (currentPickedObject === undefined) {
    return false;
  }

  if (currentPickedObject === null) {
    return false;
  }

  return currentPickedObject.name
    .split(' ')[0]
    .split('_')
    .includes(pickedObjectTypes.wall);
};

export default isWall;
